"use strict";

import angular from "angular";

angular
    .module("nucont.accounting.company.department")
    .config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.company.department", {
            url: "/importacao-de-dados/:year",
            lazyLoad(transition) {
                const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
                return import(
                    /* webpackChunkName: "feature-accounting-company-department" */ "./department.entry"
                ).then(() =>
                    $ocLazyLoad.inject("nucont.accounting.company.department")
                );
            },
            views: {
                "admin@nucont.accounting": {
                    component: "departmentComponent",
                    bindings: { companyData: "CompanyData" }
                }
            },
            params: {
                year: { value: null, dynamic: true }
            },
            data: {
                layoutConfig: {
                    model: "LayoutConfigModel5",
                    ignore: { object: "headerConfig", path: "title" },
                    setAttrs: [
                        {
                            object: "headerConfig",
                            path: "moduleTitle.text",
                            value: "Fonte de Dados"
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.description",
                            value: "Importe os dados contábeis, financeiros, fiscais e de pessoal que alimentam todas as análises."
                        },
                        {
                            object: "headerConfig",
                            path: "moduleTitle.enabled",
                            value: true
                        }
                    ]
                }
            },
            bodyClass: "department-module"
        })
        .state("nucont.accounting.company.check", {
            url: "/conferencia?year&month",
            params: {
                year: { value: null, dynamic: true },
                month: { value: null, dynamic: true }
            },
            bodyClass: "department-module"
        });
}
